module.exports = __webpack_public_path__ + "assets/gift-box-060127f1.png";